module.exports = __webpack_public_path__ + "img/daily_specials_1.750b3e1e.jpg";